// ----------------------------------------------------------------------

function path(root, sublink) {
  return `${root}${sublink}`;
}

const ROOTS_AUTH = '/auth';
const APP_ROOT = '';

// ----------------------------------------------------------------------

export const PATH_AUTH = {
  root: ROOTS_AUTH,
  login: path(ROOTS_AUTH, '/login'),
  register: path(ROOTS_AUTH, '/register'),
  loginUnprotected: path(ROOTS_AUTH, '/login-unprotected'),
  registerUnprotected: path(ROOTS_AUTH, '/register-unprotected'),
  verify: path(ROOTS_AUTH, '/verify'),
  resetPassword: path(ROOTS_AUTH, '/reset-password'),
};

export const APP_PATH = {
  root: APP_ROOT,

  users: {
    root: path(APP_ROOT, '/users'),
    list: path(APP_ROOT, '/users/list'),
    new: path(APP_ROOT, '/users/new'),

    edit: (userID) => path(APP_ROOT, `/users/${userID}/edit`),
  },

  instruments: {
    root: path(APP_ROOT, '/instruments'),
    list: path(APP_ROOT, '/instruments/list'),
    new: path(APP_ROOT, '/instruments/new'),

    view: (instrumentID) => path(APP_ROOT, `/instruments/${instrumentID}/view`),
    edit: (instrumentID) => path(APP_ROOT, `/instruments/${instrumentID}/edit`),
    calibrate: (instrumentID) => path(APP_ROOT, `/instruments/${instrumentID}/calibrate`),
    referenceCheck: (instrumentID) => path(APP_ROOT, `/instruments/${instrumentID}/check`),

    transmitters: {
      view: (instrumentID) => path(APP_ROOT, `/instruments/transmitters/${instrumentID}/view`),
      edit: (instrumentID) => path(APP_ROOT, `/instruments/transmitters/${instrumentID}/edit`),
      calibrate: (instrumentID) => path(APP_ROOT, `/instruments/transmitters/${instrumentID}/calibrate`),
    },
    switches: {
      view: (instrumentID) => path(APP_ROOT, `/instruments/switches/${instrumentID}/view`),
      edit: (instrumentID) => path(APP_ROOT, `/instruments/switches/${instrumentID}/edit`),
      calibrate: (instrumentID) => path(APP_ROOT, `/instruments/transmitters/${instrumentID}/calibrate`),
    },
    indicators: {
      view: (instrumentID) => path(APP_ROOT, `/instruments/indicators/${instrumentID}/view`),
      edit: (instrumentID) => path(APP_ROOT, `/instruments/indicators/${instrumentID}/edit`),
      calibrate: (instrumentID) => path(APP_ROOT, `/instruments/transmitters/${instrumentID}/calibrate`),
    },
  },
  references: {
    root: path(APP_ROOT, '/references'),
    list: path(APP_ROOT, '/references/list'),
    new: path(APP_ROOT, '/references/new'),
    view: (referenceID) => path(APP_ROOT, `/references/${referenceID}/view`),
    edit: (referenceID) => path(APP_ROOT, `/references/${referenceID}/edit`),
  },
  reports: {
    list: path(APP_ROOT, '/reports'),
  },
  devices: {
    root: path(APP_ROOT, '/devices'),
    list: path(APP_ROOT, '/devices/list'),
    new: path(APP_ROOT, '/devices/new'),
    view: (deviceID) => path(APP_ROOT, `/devices/${deviceID}/view`),
    edit: (deviceID) => path(APP_ROOT, `/devices/${deviceID}/edit`),
  },
  clients: {
    root: path(APP_ROOT, '/clients'),
    list: path(APP_ROOT, '/clients/list'),
  },
  database: {
    root: path(APP_ROOT, '/database/units'),
    units: path(APP_ROOT, '/database/units'),
  },
};
